import { EventEmitter } from '@angular/core';
var EventsService = /** @class */ (function () {
    function EventsService() {
        this.eventEmitters = {};
    }
    EventsService.prototype.register = function (name) {
        var key = name;
        if (this.eventEmitters[key]) {
            return this.eventEmitters[key];
        }
        var result = new EventEmitter();
        this.eventEmitters[key] = result;
        return result;
    };
    return EventsService;
}());
export { EventsService };
